.field {
  display: grid;
  gap: var(--space-2);
  min-inline-size: 0;
}

.label {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  font-weight: 600;
  font-size: var(--text-sm);
  letter-spacing: 0.01em;
}

/* Requiredness is stated in words rather than by an asterisk whose meaning has to be
   learned from a legend somewhere else on the page. */
.optional {
  font-weight: 400;
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.input {
  inline-size: 100%;
  min-inline-size: 0;
  min-block-size: 44px;
  /* 10px / 14px — `contracts/DESIGN-TOKENS.md` § Control metrics (`APP-013`). The 44px
     minimum above still sets the height. */
  padding: 0.625rem 0.875rem;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  background: var(--surface-elevated);
  color: var(--text);
  font-family: inherit;
  /* The field's own 14px text is deliberately *not* fixed by the contract — no task has
     measured it — so it keeps this repo's body size. */
  font-size: var(--text-base);
}

.input:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.input:disabled {
  color: var(--text-muted);
  cursor: not-allowed;
}

.input[aria-invalid="true"] {
  border-color: var(--danger);
  /* A second, thicker edge so the invalid state survives a monochrome or high-contrast
     rendering, where the danger hue alone would carry nothing. */
  border-inline-start-width: 3px;
}

.textarea {
  min-block-size: 5.5rem;
  resize: vertical;
  line-height: 1.5;
}

.select {
  /* The platform control keeps its own indicator; only the box is ours. */
  appearance: auto;
}

.check {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  min-block-size: 44px;
  padding-block: var(--space-2);
}

.checkbox {
  inline-size: 1.25rem;
  block-size: 1.25rem;
  margin-block-start: 0.125rem;
  flex: none;
  accent-color: var(--accent);
}

.checkbox:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.checkLabel {
  font-size: var(--text-base);
  max-inline-size: var(--measure);
}

.hint {
  font-size: var(--text-sm);
  color: var(--text-muted);
  max-inline-size: var(--measure);
}

.error {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  font-size: var(--text-sm);
  color: var(--danger);
  max-inline-size: var(--measure);
}

.marker {
  inline-size: 16px;
  block-size: 16px;
  flex: none;
  margin-block-start: 0.2em;
}
